<template>
  <div v-if="!loading" class="hidden lg:block w-64 px-4">
    <h5 class="text-sm font-medium text-gray-600 mb-2">
      Project &bull;
      <RouterLink
        v-if="project"
        :to="{
          name: 'accounts.projects.project',
          params: {
            accountId: contactRequest.accountId,
            projectId: contactRequest.projectId,
          },
        }"
        class="text-blue-700"
      >
        Open Project
      </RouterLink>
    </h5>
    <div class="flex-none py-1 text-gray-900 leading-6 truncate">
      {{ project ? project.name : 'No Project' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    project() {
      return (
        this.$store.getters['ui/contactRequestProject/itemByParent'](this.contactRequest.id) || null
      );
    },
  },
  created() {
    this.fetchProject();
  },
  methods: {
    async fetchProject() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/contactRequestProject/read', { id: this.contactRequest.id });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
